import InitiativeDetail from '../../components/light/initiative/InitiativeDetail';

const initiative = {
  title: 'Eco-Awareness & Environmental Sustainability',
  category: 'Environment',
  year: '2021',
  location: 'Lagos, Ogun & Ondo States',
  heroImage: '/light/assets/imgs/spob/initiative-5.jpg',
  need: {
    headline:
      'Poor waste disposal habits and limited environmental education are causing flooding, pollution, and public health crises in Nigerian communities.',
    body: 'Many communities lack reliable waste collection infrastructure, leading to open dumping in drainage channels and waterways. Seasonal flooding is worsened by blocked drains, and soil contamination from unmanaged waste affects food safety. Children growing up in these environments face respiratory illness, skin conditions, and reduced life expectancy. SPOB launched its Eco-Awareness initiative to tackle the root cause: knowledge and collective action.',
  },
  approach: {
    headline:
      'SPOB mobilises communities around environmental action through education, clean-up events, and school eco-clubs.',
    body: 'Monthly community clean-up drives are coordinated with local government waste management officers and youth groups. In schools, SPOB establishes eco-clubs that run composting projects, recycling awareness campaigns, and tree-planting drives. Community workshops teach households how to sort waste, reduce single-use plastics, and maintain clean surroundings. SPOB also advocates with local councils for improved waste infrastructure.',
  },
  stats: [
    { number: '60+', label: 'Community Clean-Up Events' },
    { number: '20', label: 'School Eco-Clubs' },
    { number: '8,000+', label: 'Residents Engaged' },
  ],
  next: {
    title: 'Vocational Skills & Economic Empowerment',
    href: '/light/initiative-vocational',
  },
};

export default function InitiativeEco() {
  return <InitiativeDetail initiative={initiative} />;
}
